import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtmService } from './services/gtm/gtm.service';
import { LoaderService } from './services/loader/loader.service';
import { ExpiraTokenService } from './services/expToken/expira-token.service';
import { LoaderComponent } from './services/loader/component/loader.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { BciSpinnerModule } from '@bci/styleline';
import { AuthService } from './services/auth/auth.service';
// import { ErrorsModule } from './errors';
// import { ErrorsHandler } from './errors/errors-handler/errors-handler';

@NgModule({
  imports: [
    CommonModule,
    BciSpinnerModule,
    HttpClientModule,
    OverlayModule,
    PortalModule,
    // ErrorsModule
  ],
  declarations: [LoaderComponent],
  providers: [GtmService, LoaderService, AuthService, ExpiraTokenService],
  entryComponents: [LoaderComponent]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts